export const isServerSide = /* istanbul ignore next */ (): boolean => /* istanbul ignore next */ typeof window === 'undefined';
